module.exports = __webpack_public_path__ + "static/media/logo_ipad.504a8a0d.png";